import { Group, Select } from "@mantine/core";
import classes from "./Placeholder.module.scss";

/**
 * Visual placeholder shown in the condition tree while the user is
 * dragging an entity-field over an empty group / nested group slot.
 *
 * The placeholder is intentionally non-interactive — the visible Select
 * is disabled and only renders to communicate the shape of the future
 * condition row.
 */
export default function Placeholder() {
  return (
    <Group gap={8} className={classes.placeholderRow} wrap="nowrap">
      <div className={classes.fieldPlaceholder} />
      <Select
        defaultValue="="
        data={["="]}
        disabled
        w={80}
        variant="unstyled"
        placeholder=""
      />
      <div className={classes.fieldPlaceholder} />
    </Group>
  );
}

/**
 * Variant rendered when the placeholder is the would-be parent of a
 * nested group (vs. directly inside a top-level group).
 */
export function NestedPlaceholder() {
  return (
    <div className={classes.nestedWrapper}>
      <Placeholder />
    </div>
  );
}
